import { $ } from "@utils/dom";

const WEEKDAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

class ArchiveMealsRestaurantDetails {
  constructor(el) {
    this.el = el;
    this.openingHours = $('.archive-meals__openingHours', this.el);
  }

  init() {
    if( this.openingHours ) {
      const schedule = JSON.parse( this.el.dataset.schedule );
      const today = new Date().getDay();
      const hours = schedule[ WEEKDAYS[today] ];

      if( hours.closed ) this.openingHours.innerText = this.openingHours.dataset.labelClosed;
      else {
        const format = this.openingHours.dataset.labelFormat;
        this.openingHours.innerText = format.replace('%s', hours.openingHour).replace('%s', hours.closingHour);
      }
    }
  }
  destroy() {
    this.el = null;
    this.openingHours = null;
  }
}

export default ArchiveMealsRestaurantDetails;
